/**
 * Formats the string as a caption
 * The string will be splitted on capitals and converted to lowercase, except the first letter.
 * @param text The text that has to be formatted as caption
 */
export function toCaption(text: string): string {
	if (text == null) return null;

	// Special case
	if (text === 'ID') return text;

	const captionLowerCase: string = (text.match(/([A-Z][a-z]+|[A-Z]+|[a-z]+)/g) || []).map(s => s.toLowerCase()).join(' ');
	return captionLowerCase.charAt(0).toUpperCase() + captionLowerCase.slice(1);
}
